import React from "react";
import { Grid, Box } from "@mui/material";
import CurrencyInput from "react-currency-masked-input";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";

import useStyles from "./styles";
import { Colors } from "@/theme";
import { getLocalisationVal, transformInput } from "@/utils/localizationUtil";

const ProductCard = ({ isDesktop, product, localization, onChange }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      alignItems={"center"}
      component={"main"}
      borderBottom={`1px solid ${Colors.GRAY_BORDER}`}
      paddingY={8}
    >
      <Grid item xs={2}>
        <Box className={classes.codeText}>{product.product_code}</Box>
      </Grid>
      <Grid item xs={2.5}>
        <Box width={"90%"}>
          <MobileDateTimePicker
            value={product.time}
            onChange={(value) => onChange("time", value)}
            format="DD MMM HH:mm"
            className={classes.input}
          />
        </Box>
      </Grid>
      {product.stock_types.map((stock_type) => (
        <Grid item key={stock_type.id} xs={2.5}>
          <Box width={"90%"}>
            <CurrencyInput
              value={getLocalisationVal(localization, stock_type.amount)}
              onChange={(e, value) => {
                const newStockTypes = product.stock_types.map((item) =>
                  item.id === stock_type.id
                    ? { ...item, amount: transformInput(localization, value) }
                    : item
                );
                onChange("stock_types", newStockTypes);
              }}
              className={classes.currencyInput}
              type=""
              separator={localization.digit_separator === "," ? "." : ","}
            />
          </Box>
        </Grid>
      ))}
      <Grid item xs={2.5}>
        <Box width={"90%"}>
          <CurrencyInput
            value={getLocalisationVal(localization, product.closing_stock)}
            onChange={(e, value) => {
              onChange("closing_stock", transformInput(localization, value));
            }}
            className={classes.currencyInput}
            type=""
            separator={localization.digit_separator === "," ? "." : ","}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ProductCard;
